<template>
	<div class="empty">
		<div class="wrap">
			<div class="title">Din kurv er tom</div>
			<div class="desc">
				Du har endnu ikke tilføjet varer til din indkøbskurv. Klik på bestilling for at finde varer.
			</div>
			<router-link class="button" :to="{name: 'products'}" v-if="!products">
				Gå til produkter
			</router-link>
			<div class="sub">
				Gratis levering ved ordrer over 3.000,-
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		products: (t) => t.$route.name === "products"
	}
};
</script>

<style lang="scss" scoped>
.empty {
	background-color: $white1;
	height: 100%;
	display: flex;

	.wrap {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		width: 326px;
		margin: 0 auto;

		.title {
			font-weight: 500;
			margin-bottom: 14px;
		}

		.desc {
			width: 100%;
			font-size: 13px;
			margin-bottom: 52px;
			line-height: 19px;
		}

		.button {
			cursor: pointer;
			appearance: none;
			border: 0px;
			padding: 0 1em;
			user-select: none;
			box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.10000000149011612), inset 0 1px 0 1px rgba(255, 255, 255, 0.05999999865889549);
			display: flex;
			align-items: center;
			justify-content: center;
			outline: none;
			height: 36px;
			font-size: 14px;
			background: #1A1919;
			color: $white1;
			font-weight: 400;
			letter-spacing: 1px;
			border-radius: 3px;
			margin-bottom: 10px;
		}

		.sub {
			font-size: 11px;
		}
	}
}
</style>
